import { api, api_ssr } from './utils';

export async function fetchAllMarkets(ssr = false, fetch?: any) {
	if (ssr) {
		const response = await api_ssr(fetch, 'get', 'snx-perps/markets/v2');
		if (response.status === 200) {
			const data = await response.json();
			return data;
		}
	} else {
		const response = await api('get', 'snx-perps/markets/v2');
		if (response.status === 200) {
			const data = await response.json();
			return data;
		}
	}
}
